import { useContext } from "react";
import { ApiContext } from "../../contexts/ApiContext";
import { useMutation } from "react-query";
import { QueryCallbacks } from "../../shared/interfaces/ReactQuery";

export function usePanelDelete(callbacks?: QueryCallbacks<null>) {
  const apiContext = useContext(ApiContext);
  return useMutation(
    ["deletePanel"],
    async (panelAssetId: number) => apiContext.hvSubstationApis.deleteHvSurveyableChildAsset(panelAssetId),
    {
      onSuccess: callbacks?.onSuccess,
      onError: callbacks?.onError,
    },
  );
}
